// Email validation utilities for connections
import { moduleNameFromId } from 'admin/lib/constants'
import type { EmailFormData } from './connectionTypes'

export const EMAIL_LOCAL_PART_PATTERN =
  /^[a-zA-Z0-9][a-zA-Z0-9._-]*[a-zA-Z0-9]$/

export function validateEmailLocalPart(value: string): string | true {
  if (!value) return 'Required'

  // Single character - just alphanumeric
  if (value.length === 1) {
    if (!/^[a-zA-Z0-9]$/.test(value)) {
      return 'Email must contain only letters, numbers, dots, hyphens, and underscores'
    }
  } else if (!EMAIL_LOCAL_PART_PATTERN.test(value)) {
    return 'Email must start and end with a letter or number, and contain only letters, numbers, dots, hyphens, and underscores'
  }

  // Check for consecutive dots
  if (value.includes('..')) {
    return 'Email cannot contain consecutive dots'
  }

  return true
}

export function validateEmailNotInUse(
  localPart: string,
  prefix: string,
  allEmailAddresses: string[]
): string | true {
  const fullEmail = `${prefix}.${localPart}@qualisflow.com`
  return (
    !allEmailAddresses?.includes(fullEmail) ||
    'This email address is already in use'
  )
}

export function checkAllValuesAreDifferent<T>(
  arr: T[],
  key: keyof T
): boolean {
  return arr.every((val, i, arr) => !arr[i + 1] || val[key] !== arr[i + 1][key])
}

export function createDuplicateErrorContent(
  emails: EmailFormData[],
  key: keyof EmailFormData,
  errorMessage: string
): JSX.Element {
  const displayKey =
    key === 'moduleTagDefinitionId'
      ? 'Module'
      : key === 'email'
        ? 'Email'
        : 'Email Identifier'

  return (
    <>
      <p>{errorMessage}</p>
      {emails.map((email, index) => (
        <p key={index}>
          {key === 'moduleTagDefinitionId' &&
            `Module: ${moduleNameFromId(email.moduleTagDefinitionId)}`}
          <br />
          {`Email: ${email.email}`}
        </p>
      ))}
    </>
  )
}
